module.exports = __webpack_public_path__ + "img/logo-title.87f509b1.png";